import auth from '@app/plugins/auth'
import { authModule } from './store-accessor'
export async function isAuth() {
  // Storeが持っている認証状態を確認
  if (authModule.isSignIn) {
    return true
  }

  // 未認証の状態の場合、Firebaseの認証状況を確認して最新の状況を取得。
  const authState = await auth()
  if (authState.isSignIn) {
    // Firebase上では承認ができているので、Storeも認証済に更新する
    if (authState.user) {
      authModule.setAuthUser({
        uid: authState.user.uid,
        email: authState.user.email,
        emailVerified: authState.user.emailVerified,
      })
    }
    return true
  }

  return false
}
